import React from "react";
import PdfToOfficeConverter from "../../components/PdfToOfficeConverter";

const PdfToImages = () => (
  <PdfToOfficeConverter
    target="Images"
    title="Convert PDF to Images"
    description="Export each PDF page as a JPG image, packed in a ZIP."
  />
);

export default PdfToImages;
